<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Unit Information</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        @if (modelSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Model:</span>
              <select
                class="halfWidthInputField"
                #modelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(modelSelection.Name)"
                (change)="selectionChanged(modelSelection, modelInput.value)"
                [value]="modelSelection.Value.toString()">
                @for (allowable of modelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="modelSelection.Value && modelSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (sizeSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Size:</span>
              <select
                class="halfWidthInputField"
                #sizeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
                (change)="selectionChanged(sizeSelection, sizeInput.value)"
                [value]="sizeSelection.Value.toString()">
                @for (allowable of sizeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (voltageSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Voltage:</span>
              <select
                class="halfWidthInputField"
                #voltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(voltageSelection.Name)"
                (change)="selectionChanged(voltageSelection, voltageInput.value)"
                [value]="voltageSelection.Value.toString()">
                @for (allowable of voltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="voltageSelection.Value && voltageSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (controlsSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Controls:</span>
              <select
                class="halfWidthInputField"
                #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (refrigerationSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Refrigeration:</span>
              <select
                class="halfWidthInputField"
                #refrigerationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(refrigerationSelection.Name)"
                (change)="selectionChanged(refrigerationSelection, refrigerationInput.value)"
                [value]="refrigerationSelection.Value.toString()">
                @for (allowable of refrigerationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="refrigerationSelection.Value && refrigerationSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (headerOptionsSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Header Options:</span>
              <select
                class="halfWidthInputField"
                #headerOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(headerOptionsSelection.Name)"
                (change)="selectionChanged(headerOptionsSelection, headerOptionsInput.value)"
                [value]="headerOptionsSelection.Value.toString()">
                @for (allowable of headerOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="headerOptionsSelection.Value && headerOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (compressorSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Compressor:</span>
              <select
                class="halfWidthInputField"
                #compressorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(compressorSelection.Name)"
                (change)="selectionChanged(compressorSelection, compressorInput.value)"
                [value]="compressorSelection.Value.toString()">
                @for (allowable of compressorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="compressorSelection.Value && compressorSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (compressorSoundOptionsSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Compressor Sound Options:</span>
              <select
                class="halfWidthInputField"
                #compressorSoundOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(compressorSoundOptionsSelection.Name)"
                (change)="selectionChanged(compressorSoundOptionsSelection, compressorSoundOptionsInput.value)"
                [value]="compressorSoundOptionsSelection.Value.toString()">
                @for (allowable of compressorSoundOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="compressorSoundOptionsSelection.Value && compressorSoundOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
        @if (electricalOptionsSelection) {
          <div class="configurationDetailRow">
            <span class="fullWidthConfigurationInput">
              <span class="halfWidthInputLabel">Electrical Options:</span>
              <select
                class="halfWidthInputField"
                #electricalOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(electricalOptionsSelection.Name)"
                (change)="selectionChanged(electricalOptionsSelection, electricalOptionsInput.value)"
                [value]="electricalOptionsSelection.Value.toString()">
                @for (allowable of electricalOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="electricalOptionsSelection.Value && electricalOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          </div>
        }
      </div>
      @if (isHandArrangementImageAvailable()) {
        <div class="arrangementImage">
          <img class="detailImage" [src]="handArrangementImagePath()" alt="ArrangementImage" width="290" height="260" />
        </div>
      }
    </div>
  }
</div>
